module.exports = __webpack_public_path__ + "static/media/select2@2x.a43e64c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/select2@2x.png
// module id = 442
// module chunks = 0